import React from 'react';
import useLazyLoad from 'hooks/useLazyLoad';

const LazyLoadImage = ({ src, alt, threshold = 0, width='auto', height='auto'}) => {
  const imageRef = useLazyLoad(threshold);

  return <img ref={imageRef} data-src={src} alt={alt} width={width} height={height}/>;
};

export default LazyLoadImage;